import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loader while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // Redirect to login, preserving the original page
  if (!user) {
    const target = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/auth/connexion?redirect=${encodeURIComponent(target)}`}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
}
